import React, { useEffect, useState } from "react";

const formatNumber = (num) => {
  var num_parts = num.toString().split(".");
  num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return num_parts.join(".");
};

const pad = (a, b) => {
  return (1e15 + a + "").slice(-b);
};

const CompareCatRow = ({ data, categories, handleUpdatedData, dataSum }) => {
  const [currentData, setCurrentData] = useState(null);
  let tongSum1 = "";
  if(dataSum && dataSum.report && dataSum.report.reports && dataSum.report.reports[0].data){
    tongSum1 = dataSum && dataSum.report && dataSum.report.reports ? parseInt(dataSum.report.reports[0].data.totals[0].values[0]) : "";
  }
  if(dataSum && dataSum.report && dataSum.report.reports && dataSum.report.reports[0].rows){
    tongSum1 = dataSum && dataSum.report && dataSum.report.reports ? parseInt(dataSum.report.reports[0].rows[0].metricValues[0].value) : "";
  }
  let tongSum2 = "";
  if(dataSum && dataSum.report && dataSum.report.reports2 && dataSum.report.reports2[0].data){
    tongSum2 = dataSum && dataSum.report && dataSum.report.reports2 ? parseInt(dataSum.report.reports2[0].data.totals[0].values[0]) : "";
  }
  if(dataSum && dataSum.report && dataSum.report.reports2 && dataSum.report.reports2[0].rows){
    tongSum2 = dataSum && dataSum.report && dataSum.report.reports2 ? parseInt(dataSum.report.reports2[0].rows[0].metricValues[0].value) : "";
  }
  let tong1 = "";
  if(data.report.reports && data.report.reports2 && data.report.reports[0].data){
    tong1 = data.report.reports && data.report.reports2 ? parseInt(data.report.reports[0].data.totals[0].values[0]) : "";
  }
  if(data.report.reports && data.report.reports2 && data.report.reports[0].rows && data.report.reports[0].rows.length > 0 && data.report.reports[0].rows[0].metricValues && data.report.reports[0].rows[0].metricValues.length > 0 ){
    tong1 = data.report.reports && data.report.reports2 ? parseInt(data.report.reports[0].rows[0].metricValues[0].value) : "";
  }
  let tong2 = "";
  if(data.report.reports && data.report.reports2 && data.report.reports2[0].data){
    tong2 = data.report.reports && data.report.reports2 ? parseInt(data.report.reports2[0].data.totals[0].values[0]) : "";
  }
  if(data.report.reports && data.report.reports2 && data.report.reports2[0].rows && data.report.reports2[0].rows[0] && data.report.reports2[0].rows[0].metricValues){
    tong2 = data.report.reports && data.report.reports2 ? parseInt(data.report.reports2[0].rows[0].metricValues[0].value) : "";
  }
  
  const tileTong1 = tongSum1 > 0 ? parseFloat((tong1 / tongSum1 * 100)).toFixed(2) : "";
  const tileTong2 = tongSum2 > 0 ? parseFloat((tong2 / tongSum2 * 100)).toFixed(2) : "";
  const tile = tong2 > 0 ? parseFloat((tong1 / tong2 * 100) - 100).toFixed(2) : "";
  useEffect(() => {
    if (JSON.stringify(data) !== JSON.stringify(currentData)) {
      if (currentData && handleUpdatedData) {
        handleUpdatedData(data);
      }

      setCurrentData(data);

    }
  }, [data]);
  return (
    <tr className={
        data.value == "" ? "bg-gradient-warning font-weight-bold text-dark" : ""
      }
    >
      <td>{categories.find(({ value }) => value === data.value).label}</td>
      <td>{formatNumber(tong2)}{tileTong2 ? ` (${tileTong2.replace(".",",")}%)` : ""}</td>
      <td>{formatNumber(tong1)}{tileTong1 ? ` (${tileTong1.replace(".",",")}%)` : ""}</td>
      <td className={tile > 0 ? "text-success" : "text-danger"}>{tile > 0 ? `+${tile.replace(".",",")}` : tile.replace(".",",") }%</td>
    </tr>
  );
};

export default CompareCatRow;
